module.exports = __webpack_public_path__ + "static/porsche-logo-09590459430c6324bc8a216fa6a4f374.svg";